import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const MOK_SIGNUP_RESULT_KEY = 'mok_signup_result';
const MOK_LOGIN_RESULT_KEY = 'mok_login_result';
const MOK_FINDPW_RESULT_KEY = 'mok_findpw_result';
const MOK_IDENTITY_USER_KEY = 'mok_identity_user';

function IdentityMokCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    // (0) 네이티브 앱 흐름: from=native 파라미터 감지 시 safeon:// 딥링크로 중계
    if (searchParams.get('from') === 'native') {
      const params = new URLSearchParams();
      searchParams.forEach((value, key) => {
        if (key !== 'from') params.append(key, value);
      });
      const deepLink = `safeon://mok-callback?${params.toString()}`;
      window.location.href = deepLink;
      return;
    }

    // mode: login(로그인 후) | signup(회원가입) | findpw(비밀번호 찾기)
    const mode = searchParams.get('type');
    const storageKey =
      mode === 'login'
        ? MOK_LOGIN_RESULT_KEY
        : mode === 'findpw'
          ? MOK_FINDPW_RESULT_KEY
          : MOK_SIGNUP_RESULT_KEY;

    // (1) query `data`에 결과 JSON 문자열이 담겨 오는 케이스
    const dataParam = searchParams.get('data') || '';
    if (dataParam) {
      try {
        const parsed = JSON.parse(dataParam);
        if (parsed?.resultCode && String(parsed.resultCode) !== '2000') {
          throw new Error(parsed?.resultMsg || '본인확인에 실패했습니다.');
        }

        // signup은 identityConfirm 플래그 포함, login은 결과 원본만 저장
        const payload =
          mode === 'signup'
            ? { identityConfirm: true, identityErrMsg: '', ...parsed }
            : { ...parsed };

        sessionStorage.setItem(storageKey, JSON.stringify(payload));
        setStatus('success');
        setMessage('본인인증이 완료되었습니다. 이전 화면으로 이동합니다.');
        setTimeout(() => navigate('/', { replace: true }), 300);
        return;
      } catch (e) {
        setStatus('error');
        setMessage(
          e?.message || '본인확인 결과 처리에 실패했습니다. 다시 시도해 주세요.'
        );
        setTimeout(() => navigate('/', { replace: true }), 2000);
        return;
      }
    }

    setStatus('error');
    setMessage('본인확인 결과 정보가 없습니다.');
    setTimeout(() => navigate('/', { replace: true }), 2000);
  }, [searchParams, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
        boxSizing: 'border-box',
      }}
    >
      {status === 'loading' && (
        <>
          <CircularProgress size={48} sx={{ mb: 2 }} />
          <Typography sx={{ fontSize: '16px', color: '#6B7280' }}>
            본인확인 결과를 확인하고 있습니다.
          </Typography>
        </>
      )}
      {status === 'success' && (
        <Typography
          sx={{ fontSize: '16px', color: '#2CA900', textAlign: 'center' }}
        >
          {message}
        </Typography>
      )}
      {status === 'error' && (
        <Typography
          sx={{ fontSize: '16px', color: '#DC2626', textAlign: 'center' }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
}

export default IdentityMokCallback;
export {
  MOK_SIGNUP_RESULT_KEY,
  MOK_LOGIN_RESULT_KEY,
  MOK_FINDPW_RESULT_KEY,
  MOK_IDENTITY_USER_KEY,
};
